import React from "react";
// components
import { Box, Container, Typography, Button } from "@mui/material";
import { Hero } from "components/Home/Hero";
import { MainContentBlock } from "components/Home/MainContentBlock";
import { Partners } from "components/Home/Partners";
import { Test } from "components/Home/Test";
import { Conferences } from "components/Home/Conferences";
import { Votes } from "components/Home/Votes";

// others
import { useTranslation } from "react-i18next";
import classes from "./home.module.scss";
import { Information } from "components/Home/Information";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { NewsList } from "components/NewsList";
import Organs from "pages/Organs/Organs";

const Home = () => {
  const { t } = useTranslation();

  const StyledTitle = styled(Typography)(({ theme }) => ({
    fontWeight: "600",
    fontSize: "28px",
    lineHeight: "45px",
    textAlign: "center",
    color: "#000000",
    marginBottom: "30px",
    textDecoration: "none",
    [theme.breakpoints.down(500)]: { marginBottom: "15px", fontSize: "16px" },
  }));

  const StyledShowMoreButton = styled(Button)(({ theme }) => ({
    textTransform: "none",
    padding: "3px 16px ",
    display: "block",
    border: "1px solid #706E6B",
    borderRadius: "4px",
    marginTop: "40px",
    textDecoration: "none",

    "&:where(:hover, :focus)": { backgroundColor: "#fff" },

    "&:hover": { boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25)" },

    "&:focus": { boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.15)" },

    "& .buttonLink": {
      fontSize: "16px",
      lineHeight: "20px",
      textAlign: "center",
      color: " #706E6B",
      textDecoration: "none",
    },
    [theme.breakpoints.down(500)]: {
      width: "100%",
      padding: "6px 0",
      marginTop: "26px",
      textDecoration: "none",
    },
  }));

  return (
    <Box className={classes.main}>
      <Hero />
      <Box
        sx={{
          height: {
            xs: "500px",  
            sm: "100vh", 
            md: "500px",  
          },
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Organs className={classes.organs} />
      </Box>

      <StyledTitle style={{ marginTop: "30px" }}>{t("news")}</StyledTitle>
      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingBottom: "10px",
          width: "100%",
        }}
      >
        <NewsList />
        <Link
          to="/news"
          style={{
            textDecoration: "none",
            paddingBottom: "40px",
            color: "#706E6B",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <StyledShowMoreButton
            sx={{ textDecoration: "none", padding: "3px 16px " }}
          >
            {t("showMore")}
          </StyledShowMoreButton>
        </Link>
      </Container>

      <Test />

      <StyledTitle>{t("information")}</StyledTitle>
      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingBottom: "10px",
        }}
      >
        <Information />
        <Link
          to="/info"
          style={{
            textDecoration: "none",
            paddingBottom: "40px",
            color: "#706E6B",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <StyledShowMoreButton sx={{ textDecoration: "none" }}>
            {t("showMore")}
          </StyledShowMoreButton>
        </Link>
      </Container>

      <MainContentBlock
        title={t("votes")}
        link="/vote"
        concat
        sliceName="places"
        listOf="votesList"
      >
        <Votes />
      </MainContentBlock>

      <MainContentBlock
        title={t("partners")}
        link="/partners"
        showMoreBtn={false}
      >
        <Partners />
      </MainContentBlock>

      <MainContentBlock
        title={t("conferenceTitle")}
        link="/conference"
        concat
        sliceName="conferences"
        listOf="conferences"
      >
        <Conferences />
      </MainContentBlock>
    </Box>
  );
};

export default Home;
